module.exports = __webpack_public_path__ + "img/hxjz.241d7fac.png";